import styled from 'styled-components';

export default styled.div`
    height: 0.3125rem;
    width: 100%;
    background-color: ${({ theme, white }) =>
        white ? theme.white : theme.blue};
`;
